import styled from 'styled-components';

export const Container = styled.div`
background: rgb(15, 22, 36);
max-width: 1280px;
width: 100%;
margin: auto;
`;
